/**
 * 树形数据转换
 * @param {*} data
 * @param {*} id
 * @param {*} pid
 */
export function treeDataTranslate(data, id = "id", pid = "parentId") {
  var res = [];
  var temp = {};
  for (var i = 0; i < data.length; i++) {
    temp[data[i][id]] = data[i];
  }
  for (var k = 0; k < data.length; k++) {
    if (temp[data[k][pid]] && data[k][id] !== data[k][pid]) {
      if (!temp[data[k][pid]]["children"]) {
        temp[data[k][pid]]["children"] = [];
      }
      if (!temp[data[k][pid]]["_level"]) {
        temp[data[k][pid]]["_level"] = 1;
      }
      data[k]["_level"] = temp[data[k][pid]]._level + 1;
      temp[data[k][pid]]["children"].push(data[k]);
    } else {
      res.push(data[k]);
    }
  }
  return res;
}

// date format
export function dateFormat(date, fmt = "yyyy-MM-dd HH:mm:ss") {
  //author: meizz
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
}

// 时间戳转日期(yyyy-MM-dd HH:mm:ss)
export function timestampToDate(timestamp) {
  const date = new Date(timestamp);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

// 秒数转化为时分秒
export function formatSeconds(value) {
  var secondTime = parseInt(value); // 秒
  var minuteTime = 0; // 分
  var hourTime = 0; // 小时
  if (secondTime > 60) {
    //如果秒数大于60，将秒数转换成整数
    //获取分钟，除以60取整数，得到整数分钟
    minuteTime = parseInt(secondTime / 60);
    //获取秒数，秒数取余，得到整数秒数
    secondTime = parseInt(secondTime % 60);
    //如果分钟大于60，将分钟转换成小时
    if (minuteTime > 60) {
      //获取小时，获取分钟除以60，得到整数小时
      hourTime = parseInt(minuteTime / 60);
      //获取小时后取余的分，获取分钟除以60取余的分
      minuteTime = parseInt(minuteTime % 60);
    }
  }
  var result = "" + parseInt(secondTime) + "秒";

  if (minuteTime > 0) {
    result = "" + parseInt(minuteTime) + "分" + result;
  }
  if (hourTime > 0) {
    result = "" + parseInt(hourTime) + "小时" + result;
  }
  return result;
}

// 日期相减 - 订单支付专用，不具有通用性
export function dateLess(createTime) {
  // 创建时间加上15分钟
  const date = new Date(createTime);
  const s1 = date.getTime() / 1000 + 15 * 60;
  // 当前时间(秒)
  const date2 = new Date();
  const s2 = date2.getTime() / 1000;
  // 得到倒计时(秒)
  var total = s1 - s2;
  return total;
}

export function countDown(seconds) {
  let sec = seconds;
  return cb => {
    // 先触发一遍
    cb(sec);
    // 再执行递归
    recursiveFoo(sec);

    function recursiveFoo(sec) {
      setTimeout(() => {
        cb(sec);
        sec--;
        if (sec >= 0) {
          recursiveFoo(sec);
        }
      }, 1000);
    }
  };
}

export function convertImgToBase64(url, callback, outputFormat) {
  let canvas = document.createElement("CANVAS");
  let ctx = canvas.getContext("2d");
  let img = new Image();
  img.crossOrigin = "Anonymous";
  img.onload = function() {
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
    let dataURL = canvas.toDataURL(outputFormat || "image/png");
    callback.call(this, dataURL);
    // Clean up
    canvas = null;
  };
  img.src = url;
}

export function validateLocation(object, that) {
  for (let i in object) {
    let dom = that.$refs[i];
    if (Object.prototype.toString.call(dom) !== "[object Object]") {
      //这里是针对遍历的情况（多个输入框），取值为数组
      dom = dom[0];
    }
    //第一种方法（包含动画效果）
    dom.$el.scrollIntoView({
      //滚动到指定节点
      block: "center", //值有start,center,end，nearest，当前显示在视图区域中间
      behavior: "smooth" //值有auto、instant,smooth，缓动动画（当前是慢速的）
    });
    break; //因为我们只需要检测一项,所以就可以跳出循环了
  }
}

// 数字下标排序转大写字母排序
export function num2letter(i) {
  i = typeof i == "string" ? parseInt(i) : i;
  return String.fromCharCode(65 + i);
}

// 时间自定义格式化
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string") {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), "/");
      }
    }

    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    return value.toString().padStart(2, "0");
  });
  return time_str;
}

// 字节转MB或GB
export function byte2MbOrGb(flow, type = "GB") {
  flow = Number(flow);
  let resVal = 0;
  if (type == "GB" || type == "gb") {
    resVal = flow * 1024 * 1024 * 1024;
  }
  if (type == "MB" || type == "mb") {
    resVal = flow * 1024 * 1024;
  }
  return Math.round(resVal);
}

// 只能输入数字和两位小数
export function isNumAndPoint(n) {
  n = n.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
  n = n.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
  n = n
    .replace(".", "$#$")
    .replace(/\./g, "")
    .replace("$#$", ".");
  n = n.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
  if (n.indexOf(".") < 0 && n != "") {
    //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
    n = parseFloat(n);
  }
  return n;
}

// 删除多维数组中的某一条数据
export function deleteNode(tree, key, value) {
  if (tree.length === 0) {
    return [];
  }

  for (let i = 0; i < tree.length; i++) {
    if (tree[i][key] === value) {
      tree.splice(i, 1);
      return tree;
    }

    if (tree[i].children && tree[i].children.length > 0) {
      tree[i].children = deleteNode(tree[i].children, key, value);
    }
  }

  return tree;
}

// 判断树形json数组中是否存在某个值
export function searchValueInTree(tree, key, value) {
  for (let i = 0; i < tree.length; i++) {
    if (tree[i][key] === value) {
      return true;
    }
    if (tree[i].children && tree[i].children.length > 0) {
      if (searchValueInTree(tree[i].children, key, value)) {
        return true;
      }
    }
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/lib/formatting.js